/**
 * Platform detection for Capacitor native apps.
 *
 * Uses the synchronously available window.Capacitor object that the native
 * shell injects before any JS runs. No imports from @capacitor/core needed,
 * so this has zero bundle impact on web builds.
 */

let _isNative: boolean | null = null;
let _platform: string | null = null;

export function isNativePlatform(): boolean {
  if (_isNative !== null) return _isNative;
  try {
    _isNative = !!(window as any).Capacitor?.isNativePlatform();
  } catch {
    _isNative = false;
  }
  return _isNative;
}

function getPlatform(): string {
  if (_platform !== null) return _platform;
  try {
    _platform = (window as any).Capacitor?.getPlatform?.() ?? "web";
  } catch {
    _platform = "web";
  }
  return _platform;
}

export function isAndroid(): boolean {
  return getPlatform() === "android";
}

export function isIOS(): boolean {
  return getPlatform() === "ios";
}
